import { render, staticRenderFns } from "./FairLabelList.vue?vue&type=template&id=31122654&scoped=true&"
import script from "./FairLabelList.vue?vue&type=script&lang=js&"
export * from "./FairLabelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31122654",
  null
  
)

component.options.__file = "FairLabelList.vue"
export default component.exports